function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "bifsi");

var _ref3 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "543.49 385.66 657.12 330.9 713.47 392.84 687.17 421.57 628.48 461.96 543.49 385.66",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "523.77 396.43 448.64 461.96 501.23 504.15 597.02 513.13 620.5 491.59 523.77 396.43",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref5 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "673.09 321.02 740.71 382.96 840.25 330.9 846.83 281.52 806.44 224.97 673.09 321.02",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "430.79 483.96 370.69 557.57 439.25 606.94 507.8 545.45 430.79 483.96",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 380.08,
  y: 620.11,
  width: 89.22,
  height: 79,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref8 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "375.39 723.49 375.39 816.85 503.11 793.51 487.14 731.57 375.39 723.49",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref9 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "830.86 405.41 775.45 444.01 803.16 472.74 744.46 534.23 799.87 583.15 912.57 490.69 830.86 405.41",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref10 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "601.72 602.9 605.47 744.74 770.76 734.86 770.76 636.12 697.51 627.14 697.51 602.9 601.72 602.9",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref11 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "539.73 545.45 490.9 595.72 556.64 613.67 590.45 573.28 539.73 545.45",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref12 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "704.08 437.73 753.85 479.02 665.58 567.89 616.74 534.23 704.08 437.73",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref13 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "520.95 642.4 528.46 759.1 573.54 751.02 562.27 637.01 520.95 642.4",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref14 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "548.18 206.12 618.62 250.11 506.86 306.66 462.72 268.96 548.18 206.12",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref15 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "601.72 195.35 653.37 246.51 734.13 206.12 658.06 131.61 601.72 195.35",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref16 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "433.14 255.87 492.31 182.26 437.84 149.94 386.19 210.09 433.14 255.87",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref17 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "251.42 297.68 207.28 367.7 269.26 373.09 318.1 324.62 251.42 297.68",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref18 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "199.33 454.78 309.21 479.02 297 519.86 309.21 523.01 297 571.48 173.98 551.28 199.33 454.78",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref19 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "239.25 605.15 231.73 677.86 196.99 677.86 188.53 758.65 294.65 758.65 294.65 605.15 239.25 605.15",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref20 =
/*#__PURE__*/
React.createElement("rect", {
  x: 84.26,
  y: 579.56,
  width: 60.1,
  height: 49.37,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref21 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "334.05 114.6 274.9 208.83 343.14 231.21 401.16 150.84 334.05 114.6",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref22 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "139.66 255.87 209.63 292.59 156.57 365.08 84.26 330.9 139.66 255.87",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref23 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "67.91 373.09 124.02 405.41 61.84 483.95 7.25 437.73 67.91 373.09",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref24 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "353.5 341.72 402.03 371.41 321.65 451.14 290.54 426.5 353.5 341.72",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var _ref25 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "590.45 5.56 590.45 88.19 632.71 82.39 686.24 15.71 590.45 5.56",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 10
});

var SvgBifsi = function SvgBifsi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "ee492522-a99b-42d6-a551-9b8c76aa158f",
    "data-name": "Layer 1",
    viewBox: "0 0 919.91 822.85",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBifsi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bifsi.2f067f9d.svg";
export { ForwardRef as ReactComponent };